import React, { Fragment, useRef } from "react";
import ScrollToBottom from "react-scroll-to-bottom";
import { connect } from "react-redux";
import { getGifsSearch } from "../../../actions/gif";

import GifItem from "./GifItem";
import DiscussionChatMessageItem from "../Innovators/DiscussionChatMessageItem";

const IndustryChat = ({
  auth: { user, isAuthenticated },
  messages,
  message,
  setMessage,
  showGIFs,
  setshowGIFs,
  gifSearch,
  setGifSearch,
  sendMessage,
  gifs,
  setGif,
  foundGif,
  text,
  setText,
  getGifsSearch,
  setShowChat,
  maxLength,
}) => {
  const inputRef = useRef(null);

  return (
    <Fragment>
      <div className="live-stream-side-container border-left grey">
        <div className="container-name">
          <i
            className="far fa-window-close fa-2x green close-window"
            onClick={() => setShowChat(false)}
          ></i>
          <p className="container-title green">
            <i className="far fa-comments green mr-5"></i>Chat
          </p>
          <i className="fas fa-external-link-alt fa-lg green pop-out"></i>
        </div>
        <ScrollToBottom className="all-content">
          {messages.map((message, index) => (
            <DiscussionChatMessageItem
              key={index}
              user={user}
              message={message}
            />
          ))}
        </ScrollToBottom>
        {user && user.role !== "employer" && (
          <div>
            <div className="comment-gif-input-hidden">
              {showGIFs && foundGif === "" && (
                <div className="giphy-container">
                  <div className="wrap-container">
                    <div className="powered-by-giphy green">Powered By</div>
                    <img
                      src={
                        "https://ime.sfo3.cdn.digitaloceanspaces.com/img/Giphy_Logo.png"
                      }
                      style={{
                        width: "80px",
                        margin: "0px 10px",
                      }}
                      alt="logo"
                    />
                    <i
                      className="far fa-times-circle fa-lg green gif-x"
                      onClick={() => setshowGIFs(false)}
                    ></i>
                  </div>
                  <div className="gifs" id="green-scroll">
                    {!gifSearch &&
                      gifs.map((gif) => (
                        <div
                          className="gif-choice"
                          onClick={(e) => {
                            setGif(e.target.attributes["src"].value);
                            inputRef.current.focus();
                          }}
                        >
                          <GifItem key={gif.id} gif={gif} />
                        </div>
                      ))}
                    {gifSearch &&
                      gifs.map((gif) => (
                        <div
                          className="gif-choice"
                          onClick={(e) => {
                            setGif(e.target.attributes["src"].value);
                            inputRef.current.focus();
                          }}
                        >
                          <GifItem key={gif.id} gif={gif} />
                        </div>
                      ))}
                  </div>
                  <form
                    className="gif-input-hidden"
                    onSubmit={(e) => {
                      e.preventDefault();
                      getGifsSearch({ text });
                      setText("");
                      setGifSearch(true);
                    }}
                  >
                    <input
                      type="text"
                      className="gif-input"
                      name="text"
                      value={text}
                      onChange={(e) => setText(e.target.value)}
                      placeholder="Search for GIFs..."
                    />
                    <button
                      type="submit"
                      onSubmit={(e) => {
                        e.preventDefault();
                        getGifsSearch({ text });
                        setText("");
                        setGifSearch(true);
                        setshowGIFs(false);
                      }}
                      className="gif-input-button background-green"
                    >
                      <i className="fas fa-search"></i>
                    </button>
                  </form>
                </div>
              )}
            </div>
            {isAuthenticated && !user.banned && !user.timed_out && (
              <div className="chat-message-container">
                {gifs && foundGif !== "" && (
                  <div className="selected-gif-container">
                    <div>
                      <img
                        className="selected-gif"
                        alt="gif-avatar"
                        src={gifs && foundGif}
                      />
                      <i
                        className="far fa-times selected-gif-x"
                        onClick={() => {
                          setGif("");
                          setshowGIFs(false);
                        }}
                      ></i>
                    </div>
                  </div>
                )}
                {/* {mention && (
                  <div className="room-users-container">
                    <div className="room-users">
                      <ul>
                        {viewerCount &&
                          viewerCount
                            .filter((y) => {
                              return y.channelid.match(str.substring(1));
                            })
                            .map((c) => {
                              if (c.channelid !== "") {
                                return (
                                  <li
                                    onClick={(e) => {
                                      addMention(e, message);
                                      inputRef.current.focus();
                                    }}
                                    className={`room-user-item ${
                                      c.role === "innovator"
                                        ? "green"
                                        : c && c.role === "mentor"
                                        ? "red"
                                        : c && c.role === "employer"
                                        ? "blue"
                                        : ""
                                    } bold`}
                                    value={`@${c.channelid}`}
                                  >
                                    @{c.channelid}
                                  </li>
                                );
                              }
                            })}
                      </ul>
                    </div>
                  </div>
                )} */}
                <div className="chat-input-hidden">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${
                      user && user.avatar
                    }`}
                    className="chat-avi-user"
                    alt="avatar"
                  />
                  <input
                    className="chat-input"
                    type="text"
                    value={message}
                    ref={inputRef}
                    onChange={(e) => setMessage(e.target.value)}
                    maxLength={100}
                    onKeyPress={(e) => {
                      if (message.length <= maxLength && e.key === "Enter") {
                        sendMessage(e);
                      }
                    }}
                    placeholder="Type message here..."
                  />
                  {isAuthenticated &&
                    user.founding_supporter_type !== "Good" &&
                    user.founding_supporter_type !== "" && (
                      <div
                        className={`gif-button-container ${
                          user && user.role === "innovator"
                            ? "green"
                            : user && user.role === "mentor"
                            ? "red"
                            : user && user.role === "employer"
                            ? "blue"
                            : ""
                        }`}
                        onClick={() => setshowGIFs(true)}
                      >
                        <p className="gif-button">GIF</p>
                      </div>
                    )}
                  <p className="white character-counter-comment">
                    {message.length}/{maxLength} characters
                  </p>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  gif: state.gif,
  episode: state.industryweek,
});

export default connect(mapStateToProps, { getGifsSearch })(IndustryChat);
